
import { mapGetters } from 'vuex';
import SocialMediaType from '@/enums/SocialMediaType';

const UNIFIED_ICON_NAMES = {
  facebook: { 20: 'ic-social-facebook-20px', 24: 'ic-social-facebook-24px' },
  instagram: {
    20: 'ic-social-instagram-20px',
    24: 'ic-social-instagram-24px'
  },
  naver: { 20: 'ic-social-naver-20px', 24: 'ic-social-naver-24px' },
  vimeo: { 20: 'ic-social-vimeo-20px', 24: 'ic-social-vimeo-24px' },
  youtube: { 20: 'ic-social-youtube-20px', 24: 'ic-social-youtube-24px' }
};

export default {
  name: 'AppSocialMediaIcon',
  props: {
    socialMediaType: {
      type: Number,
      required: true
    },
    size: {
      type: String,
      default: 'small',
      validator: v => ['small', 'medium', 'large', 'responsive'].includes(v)
    },
    iconSize: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters('widget', ['isMobileViewport']),
    SocialMediaType: () => SocialMediaType,
    iconType() {
      const type = SocialMediaType.toKey(this.socialMediaType).toLowerCase();
      return type.startsWith('naver') ? 'naver' : type;
    },
    iconName() {
      if (this.iconSize || this.size === 'responsive') {
        return UNIFIED_ICON_NAMES[this.iconType]?.[this.resolvedIconSize];
      }
      return `${this.iconType}-${this.size}`;
    },
    resolvedIconSize() {
      if (this.iconSize) return this.iconSize;
      switch (this.size) {
        case 'large':
          return 36;
        case 'medium':
          return 24;
        case 'responsive':
          return this.isMobileViewport ? 20 : 24;
        default:
          return 18;
      }
    },
    showCustomIcon() {
      // HACK: svgo package에서 linear-gradient 적용이 안되는 문제가 있다.
      // 네이버, 인스타그램 svg 파일에서 linear-gradient를 사용하고 있어서 색상 적용이 안되는 문제
      // svgo package 버전을 ^3.1 로 업그레이드하면 해결될 것으로 예상되나 dependency 이슈로 업그레이드 불가
      // REF: https://github.com/svg/svgo/issues/1282
      return (
        ['large', 'medium'].includes(this.size) &&
        [
          SocialMediaType.INSTAGRAM,
          SocialMediaType.NAVER_CAFE,
          SocialMediaType.NAVER_BLOG
        ].includes(this.socialMediaType)
      );
    },
    customIconComponent() {
      switch (this.socialMediaType) {
        case SocialMediaType.INSTAGRAM:
          return 'AppInstagramIcon';
        case SocialMediaType.NAVER_CAFE:
        case SocialMediaType.NAVER_BLOG:
          return 'AppNaverIcon';
        default:
          return '';
      }
    }
  }
};
